import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ApiService } from '../api/api.service';
import { WrapperService } from '../api/wrapper.service';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/observable/of';
import { SettingsTemplate } from './model/settings-template';
@Injectable()
export class SettingsService {

	constructor(private apiService: ApiService, private wrapper: WrapperService) {
	}

	public getTimeEntryNoteTemplates(): Observable<any> {
		return this.apiService.getTimeEntryNoteTemplates();
	}

	public saveTemplate(template: SettingsTemplate): Observable<any> {
		return this.apiService.saveTemplate(template);
	}

	public deleteTemplate(id: number): Observable<any> {
		return this.apiService.deleteTemplate(id);
	}

	public deleteHoliday(id: number): Observable<any> {
		return this.wrapper.wrapDeleteRequest('/settings/holidays/' + id, {}, 'deleteHoliday');
	}

	public createTask(newTask: any): Observable<any> {
		return this.wrapper.wrapPostRequest('/settings/tasks', newTask, 'createTask');
	}
	public createEmployee(newEmployee: any): Observable<any> {
		return this.wrapper.wrapPostRequest('/settings/user', newEmployee, 'createEmployee');
	}

	public getEmployeeAccessKey(employeeId: number): Observable<any> {
		return this.wrapper.wrapGetRequest(`/settings/user/${employeeId}/access_key`, 'getEmployeeAccessKey');
	}

	public saveProject(project: any): Observable<any> {
		return this.wrapper.wrapPostRequest('/settings/projects', project, 'saveProject');
	}

	public deleteProject(id: number): Observable<any> {
		return this.wrapper.wrapDeleteRequest('/settings/projects/' + id, {}, 'deleteProject');
	}
}



// WEBPACK FOOTER //
// ./src/app/settings/settings.service.ts